import Header from './connected';

export default Header;